import { ChainLink } from '@creditornot/cb-icons';
import { colors, typographyCss } from '@creditornot/cb-ingredients';
import { LegacyPopover } from '@creditornot/cb-popover';
import { cssThemedValue } from '@creditornot/cb-sc-utils';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

const Root = styled.div`
  position: absolute;
  inset-block-start: 8px;
  inset-inline-start: 8px;
`;

const PopoverContent = styled.div`
  ${typographyCss.Body3()}
`;

const IconContainer = styled.div`
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background-color: ${colors.lime100};
`;

const StyledChainLink = styled(ChainLink)`
  position: relative;
  height: 12px;
  fill: ${cssThemedValue({ light: colors.salt100, dark: colors.pepper100 })};
`;

export const AttachedToOfferIcon = () => {
  return (
    <Root>
      <LegacyPopover
        content={
          <PopoverContent>
            <FormattedMessage id="photo-shoot.photo-linked" />
          </PopoverContent>
        }
        placement="top"
        showOnClick={false}
      >
        <IconContainer>
          <StyledChainLink />
        </IconContainer>
      </LegacyPopover>
    </Root>
  );
};
